import * as React from 'react'

import { Button as ButtonPresenter, IProps } from './presenter'

export const Button = React.forwardRef<HTMLButtonElement, IProps>(
  (props, ref) => <ButtonPresenter {...props} ref={ref} />,
)

export default Button
